import type { Menu } from "types/menu"

export const universalMenuItems = (options?: any): Menu => {
  return [
    {
      label: "System",
      items: [
        {
          label: "Devices",
          icon: "pi pi-car",
          to: "/devices",
        },
        {
          label: "Users",
          icon: "pi pi-fw pi-id-card",
          to: "/users",
        },
        // TODO: SETTINGS removed until further notice
        // {
        //   label: "Settings",
        //   icon: "pi pi-fw pi-cog",
        //   to: "/settings",
        // },
        {
          label: "Help",
          icon: "pi pi-question",
          to: "http://help.routereports.com/en/",
        },
      ],
    },
  ]
}
